import { createAction } from '@reduxjs/toolkit';

export const APP_LOADED_RECORDED = 'APP_LOADED_RECORDED';

export const setHasReportedAppLoaded = createAction(APP_LOADED_RECORDED);
